import React from "react";
import moment from "moment";

import { Box, StaticField } from "@intech/web-ui";

import { LoadingComponent } from "../../../../components/LoadingComponent";

interface IProps {
  saldo: any[] | null
}

export const HistoricoBD: React.FC<IProps> = ({
  saldo
}) => {

  if (saldo !== null && saldo !== undefined && saldo.length > 0) {
    return (
      <Box title={"Histórico"}>
        <div className={"table-responsive"}>
          <table className={"table table-bordered table-striped table-hover"}>
            <thead>
              <tr className={"text-center"}>
                <th>Referência</th>
                <th>Rubrica</th>
                <th>Valor (R$)</th>
              </tr>
            </thead>
            <tbody>
              {saldo.map((item: any, index: number) => {
                return (
                  <tr key={index}>
                    <td className={"text-center"}>
                      <StaticField
                        value={moment(item.DT_REFERENCIA, "DD/MM/yyyy").format("MM/yyyy")}
                      />
                    </td>
                    <td>
                      <StaticField
                        value={item.DS_RUBRICA}
                      />
                    </td>
                    <td className={"text-right"}>
                      <StaticField
                        value={item.VALOR_MC}
                        type={"money"}
                      />
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </Box>
    )
  }

  return (
    <LoadingComponent />
  );
}